<template>
  <v-row justify="center">
    <v-dialog
      v-model="getPreordiniEdit"
      persistent
      max-width="600px"
    >
      <v-form
        ref="form"
        v-model="valid"
        :lazy-validation="true"
        autocomplete="off"
      >
        <v-card>
          <v-card-title>
            <span class="headline primary--text font-weight-bold">Modifica Preordine</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-row>
                <v-select
                  label="Stato"
                  :items="[
                  'Inserito',
                  'Ordinato',
                  'Arrivato',
                  'Consegnato'
                  ]"
                  v-model="preorder.state"
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-row>

              <v-row>
                <v-autocomplete
                  v-model="preorder.customer_id"
                  :items="customers"
                  :search-input.sync="searchCustomer"
                  hide-no-data
                  hide-selected
                  item-text="fullname"
                  item-value="id"
                  label="Cliente"
                  :rules="[rules.required]"
                ></v-autocomplete>
              </v-row>

              <v-row>
                <v-autocomplete
                  v-model="preorderId"
                  :items="articles"
                  :search-input.sync="search"
                  hide-no-data
                  hide-selected
                  item-text="text"
                  item-value="id"
                  label="Articolo"
                  :rules="[rules.required]"
                ></v-autocomplete>
              </v-row>

              <v-row>
                <v-textarea
                  label="Note"
                  v-model="preorder.description"
                ></v-textarea>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="edit"
            >Salva</v-btn>
            <v-btn
              color="primary"
              @click="dismiss"
            >Annulla</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
  import axios from 'axios'
  import { mapGetters, mapMutations } from 'vuex'

  export default {
    name: 'EditDialog',

    props: {
      kind: {
        type: String,
        default: null
      }
    },

    data() {
      return {
        menu: false,
        valid: false,
        customers: [],
        articles: [],
        search: null,
        searchCustomer: null,
        rules: {
          required: (value) => !!value || 'Campo obbligatorio.',
        },
        config: {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        },
      }
    },

    computed: {
      ...mapGetters([
        'getPreordiniEdit',
        'getPreordiniSelected',
      ]),

      preorder: {
        get() {
          return this.getPreordiniSelected
        },
        set(val) {
          console.log(val)
          this.SET_PREORDINI_SELECTED(val)
        }
      },

      preorderId: {
        get() {
          return this.getPreordiniSelected.device_id ? this.getPreordiniSelected.device_id :
            this.getPreordiniSelected.accessory_id ? this.getPreordiniSelected.accessory_id :
              this.getPreordiniSelected.replacement_id
        },
        set(val) {
          let preorder = this.getPreordiniSelected

          preorder.device_id ? preorder.device_id = val :
            preorder.accessory_id ? preorder.accessory_id = val :
              preorder.replacement_id = val

          this.SET_PREORDINI_SELECTED(preorder)
        }
      },
    },

    methods: {
      ...mapMutations([
        'SET_PREORDINI_SELECTED'
      ]),

      async fetchCustomers() {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API}/v2/customers/fetch`,
          this.config
        )

        let customers = data.map(customer => {
          customer.fullname = `${customer.name} ${customer.surename}`
          return customer
        })

        this.customers = customers
      },

      async _fetch() {
        let articles

        switch (this.kind) {
          case 'devices':
            let { data: devices } = await axios.get(
              `${process.env.VUE_APP_API}/v2/smartphones/blueprint/fetch`,
              this.config
            )

            articles = devices.map((device, index) => {
              devices[index].text = `${device.brand} ${device.model} ${device.color} ${device.disk_space} ${device.ram}`
              return device
            })

            break
          case 'accessori':
            let { data: accessories } = await axios.get(
              `${process.env.VUE_APP_API}/accessories/fetch`,
              this.config
            )

            articles = accessories.map((accessory, index) => {
              accessories[index].text = `${accessory.brand} ${accessory.model} ${accessory.color} ${accessory.desctiption}`
              return accessory
            })

            break
          case 'ricambi':
            let { data: replacements } = await axios.get(
              `${process.env.VUE_APP_API}/replacements/fetch`,
              this.config
            )

            articles = replacements.map((replacement, index) => {
              replacements[index].text = `${replacement.name} ${replacement.model} ${replacement.color} ${replacement.state}`
              return replacement
            })

            break
        }

        this.articles = articles
      },

      dismiss() {
        this.$emit('dismiss')
      },

      async edit() {
        if (this.$refs.form.validate()) {
          const { data } = await axios.post(
            `${process.env.VUE_APP_API}/preorders/update/${this.kind}`,
            this.preorder,
            this.config
          )

          if (data.status) {
            this.$emit('saved')
          }
        }
      },
    },

    watch: {
      kind: {
        handler() {
          this._fetch()
        },
        immediate: true,
        deep: true
      }
    },

    async mounted() {
      await this.fetchCustomers()
    },
  }
</script>